import axios from "axios";
import Cookies from "js-cookie";

import { setAccessToken, setRefreshToken } from "../slices/authSlice";
import getTenantId from "../../components/Tenent";

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH_API}`,
  withCredentials:'true',
  headers: {
    accept: `application/json`,
  },
});

const setUpInterceptors = (getState, dispatch) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const parsedURL = new URL(window.location.href);

      const subdomain = parsedURL?.hostname?.split(".")?.[0];
      const tenantId = getTenantId();

      if (subdomain === "localhost") {
        config.headers["x-tenant-id"] = tenantId;
      } else {
        config.baseURL = config.baseURL?.replace("www", subdomain);
        config.headers["x-tenant-id"] = subdomain;
      }

      const token = Cookies.get("access_token");
      const refresh_token = Cookies.get("refresh_token");
      if (token && config.url !== "/core/user/login") {
        config.headers["Authorization"] = `Bearer ${token}`;
        config.headers["Refresh"] = `Bearer ${refresh_token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const originalConfig = err.config;

      if (originalConfig.url !== "/core/user/login" && err.response) {
        const errorMessage = err.response?.data?.error || "";

        if (
          err.response.status === 401 &&
          errorMessage.includes("access token has expired") &&
          !originalConfig._retry
        ) {
          originalConfig._retry = true;

          const accessToken = Cookies.get("access_token");
          const refreshToken = Cookies.get("refresh_token");

          if (!refreshToken || !accessToken) {
            dispatch(setAccessToken(null));
            dispatch(setRefreshToken(null));
            return Promise.reject(err);
          }

          try {
            const parsedURL = new URL(window.location.href);
            const subdomain = parsedURL?.hostname?.split(".")?.[0];
            const tenantId = getTenantId();

            const refreshHeaders = {
              "Content-Type": "application/json",
              Authorization: `Bearer ${refreshToken}`,
              "x-tenant-id": subdomain === "localhost" ? tenantId : subdomain,
            };

            // Request new tokens
            const { data } = await axiosInstance.post(
              "/auth/core/refresh",
              {
                access_token: accessToken,
                refresh_token: refreshToken,
              },
              { headers: refreshHeaders }
            );

            // Save new tokens
            dispatch(setAccessToken(data?.data?.access_token));
            dispatch(setRefreshToken(data?.data?.refresh_token));

            // Retry original request with new access token
            originalConfig.headers[
              "Authorization"
            ] = `Bearer ${data?.data?.access_token}`;
            originalConfig.headers[
              "Refresh"
            ] = `Bearer ${data?.data?.refresh_token}`;
            return axiosInstance(originalConfig);
          } catch (_error) {
            dispatch(setAccessToken(null));
            dispatch(setRefreshToken(null));
            return Promise.reject(_error);
          }
        }
      }
      return Promise.reject(err);
    }
  );
};

const authBaseQuery =
  () =>
  async (
    { responseType, url, method, body, params, ...requestOpts },
    { getState, dispatch }
  ) => {
    setUpInterceptors(getState, dispatch);
    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
        responseType: responseType || undefined,
      };
      const result = await axiosInstance(axiosOptions);
      return { data: result?.data };
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };
export default authBaseQuery();
